<div class="container-fluid">
  <div class="row justify-content-center align-items-center main-div">
      <div class="col-lg-2">
        <button class="btn btn-grid" (click)="login()"><div class="btn-size">Login</div></button>
        <br>
        <button class="btn btn-grid mt-2" (click)="register()"><div class="btn-size">Register</div></button>
      </div>
  </div>
</div>
